// import React, { useState } from "react";
// import "./Contact.css";

// const Contact = ({ t }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });
//   const [status, setStatus] = useState("");

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setStatus("sending");

//     // Simulate form submission
//     setTimeout(() => {
//       setStatus("success");
//       setFormData({ name: "", email: "", message: "" });
//       setTimeout(() => setStatus(""), 3000);
//     }, 1500);
//   };

//   return (
//     <section id="contact" className="section contact-section">
//       <h2 className="section-title">{t.contact.title}</h2>
//       <div className="contact-container">
//         <div className="contact-form-container">
//           <form className="contact-form" onSubmit={handleSubmit}>
//             <div className="form-group">
//               <label htmlFor="name">{t.contact.name}</label>
//               <input
//                 type="text"
//                 id="name"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//                 placeholder={t.contact.name}
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="email">{t.contact.email}</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 placeholder={t.contact.email}
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="message">{t.contact.message}</label>
//               <textarea
//                 id="message"
//                 name="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 required
//                 rows="5"
//                 placeholder={t.contact.message}
//               ></textarea>
//             </div>
//             <button
//               type="submit"
//               className="submit-btn"
//               disabled={status === "sending"}
//             >
//               {status === "sending" ? t.contact.sending : t.contact.send}
//             </button>
//             {status === "success" && (
//               <div className="form-status success">{t.contact.success}</div>
//             )}
//             {status === "error" && (
//               <div className="form-status error">{t.contact.error}</div>
//             )}
//           </form>
//         </div>
//         <div className="contact-social">
//           <h3>Connect with me</h3>
//           <div className="social-links">
//             <a
//               href="https://github.com/alirezaadibi2006"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="social-link"
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
//               </svg>
//               <span>GitHub</span>
//             </a>
//             <a
//               href="https://linkedin.com/in/alireza-adibi"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="social-link"
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
//               </svg>
//               <span>LinkedIn</span>
//             </a>
//             <a
//               href="mailto:alireza.adibi.2006@gmail.com"
//               className="social-link"
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
//               </svg>
//               <span>Email</span>
//             </a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;
///////////////////////////////////////////////
// import React, { useState } from "react";
// import "./Contact.css";

// const Contact = ({ t }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });
//   const [status, setStatus] = useState("");

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setStatus("sending");

//     const form = e.target;
//     const data = new FormData(form);

//     fetch("/", {
//       method: "POST",
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       body: new URLSearchParams(data).toString(),
//     })
//       .then(() => {
//         setStatus("success");
//         setFormData({ name: "", email: "", message: "" });
//         setTimeout(() => setStatus(""), 3000);
//       })
//       .catch((err) => {
//         console.error(err);
//         setStatus("error");
//       });
//   };

//   return (
//     <section id="contact" className="section contact-section">
//       <h2 className="section-title">{t.contact.title}</h2>
//       <div className="contact-container">
//         <div className="contact-form-container">
//           <form
//             name="contact"
//             method="POST"
//             data-netlify="true"
//             onSubmit={handleSubmit}
//             className="contact-form"

//           >
//             <input type="hidden" name="form-name" value="contact" />

//             <div className="form-group">
//               <label htmlFor="name">{t.contact.name}</label>
//               <input
//                 type="text"
//                 id="name"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//                 placeholder={t.contact.name}
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="email">{t.contact.email}</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 placeholder={t.contact.email}
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="message">{t.contact.message}</label>
//               <textarea
//                 id="message"
//                 name="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 required
//                 rows="5"
//                 placeholder={t.contact.message}
//               ></textarea>
//             </div>

//             <button
//               type="submit"
//               className="submit-btn"
//               disabled={status === "sending"}
//             >
//               {status === "sending" ? t.contact.sending : t.contact.send}
//             </button>

//             {status === "success" && (
//               <div className="form-status success">{t.contact.success}</div>
//             )}
//             {status === "error" && (
//               <div className="form-status error">{t.contact.error}</div>
//             )}
//           </form>
//         </div>

//         <div className="contact-social">
//           <h3>Connect with me</h3>
//           <div className="social-links">
//             <a
//               href="https://github.com/alirezaadibi2006"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="social-link"
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
//               </svg>
//               <span>GitHub</span>
//             </a>
//             <a
//               href="https://linkedin.com/in/alireza-adibi"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="social-link"
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
//               </svg>
//               <span>LinkedIn</span>
//             </a>
//             <a
//               href="mailto:alireza.adibi.2006@gmail.com"
//               className="social-link"
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
//               </svg>
//               <span>Email</span>
//             </a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;
//////////////////////////////////
import React, { useState } from "react";
import "./Contact.css";

const Contact = ({ t }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    // ارسال واقعی به Netlify
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData }),
    })
      .then(() => {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
        setTimeout(() => setStatus(""), 3000);
      })
      .catch(() => {
        setStatus("error");
      });
  };

  return (
    <section id="contact" className="section contact-section">
      <h2 className="section-title">{t.contact.title}</h2>
      <div className="contact-container">
        <div className="contact-form-container">
          <form
            name="contact"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
            className="contact-form"
            netlify
          >
            <input type="hidden" name="form-name" value="contact" />
            <div className="form-group">
              <label htmlFor="name">{t.contact.name}</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder={t.contact.name}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t.contact.email}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder={t.contact.email}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">{t.contact.message}</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder={t.contact.message}
              />
            </div>
            <button
              type="submit"
              className="submit-btn"
              disabled={status === "sending"}
            >
              {status === "sending" ? t.contact.sending : t.contact.send}
            </button>
            {status === "success" && (
              <div className="form-status success">{t.contact.success}</div>
            )}
            {status === "error" && (
              <div className="form-status error">{t.contact.error}</div>
            )}
          </form>
        </div>
        <div className="contact-social">
          <h3>Connect with me</h3>
          <div className="social-links">
            <a
              href="https://github.com/alirezaadibi2006"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <span>GitHub</span>
            </a>
            <a
              href="https://linkedin.com/in/alireza-adibi"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <span>LinkedIn</span>
            </a>
            <a
              href="mailto:alireza.adibi.2006@gmail.com"
              className="social-link"
            >
              <span>Email</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
